import { a as attr, o as observable } from './vivid-element.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const FormElement = (Base) => {
  class FormElementElement extends Base {
    constructor(...args) {
      super(...args);
      this.errorValidationMessage = "";
      /**
       * @internal
       */
      this.forceErrorDisplay = false;
      /**
       * @internal
       */
      this.hasBeenTouched = false;
      this.#handleInvalidEvent = () => {
        this.forceErrorDisplay = true;
        this.validate();
      };
      this.addEventListener("blur", () => {
        this.hasBeenTouched = true;
        this.forceErrorDisplay = false;
        this.validate();
      });
      this.addEventListener("focus", () => {
        this.hasBeenTouched = false;
      });
      this.addEventListener("invalid", () => {
        this.proxy.dispatchEvent(new Event("invalid"));
      });
    }
    /**
     * @internal
     */
    connectedCallback() {
      super.connectedCallback();
      this.proxy.addEventListener("invalid", this.#handleInvalidEvent);
    }
    #handleInvalidEvent;
    /**
     * @internal
     */
    disconnectedCallback() {
      super.disconnectedCallback();
      this.proxy.removeEventListener("invalid", this.#handleInvalidEvent);
    }
    /**
     * @internal
     */
    formResetCallback() {
      this.forceErrorDisplay = false;
      super.formResetCallback();
      this.validate();
    }
    /**
     * @internal
     */
    validate() {
      super.validate();
      const shouldShowValidationError = this.forceErrorDisplay || this.hasBeenTouched && this.dirtyValue;
      this.errorValidationMessage = shouldShowValidationError ? this.validationMessage : "";
    }
  }
  __decorateClass([
    attr
  ], FormElementElement.prototype, "label");
  __decorateClass([
    observable
  ], FormElementElement.prototype, "errorValidationMessage");
  return FormElementElement;
};

export { FormElement as F };
